 const ErrorPage =() =>{
    return(
        <>
        <div className="error">
            <h4>
                Página no encontrada
            </h4>

        </div>
        </>
    )
}

export default ErrorPage;